import _omitBy from 'lodash/omitBy'
import _isNil from 'lodash/isNil'

import {StringObject} from './interfaces'

export const resetTracking = (): boolean => {
  if (window.heap) {
    window.heap.resetIdentity()
    window.heap.clearEventProperties()
  }

  return true
}

export const setupTracking = (user: StringObject, storeAttributes: StringObject = {}): boolean => {
  if (!user || storeAttributes.ghosted) {
    resetTracking()
    return false
  }

  /* eslint-disable camelcase */
  const {
    id,
    email,
    name,
    job_title,
    account,
    channels,
    analyst = null,
    created_at,
    is_mifid,
    is_gdpr_compliant,
    country_id,
  } = user

  if (window.heap) {
    const userProps = {
      id: `${id}`,
      email,
      Name: name,
      'Account ID': account ? account.id : null,
      'Account Name': account ? account.name : null,
      'Account Type ID': account ? account.account_type_id : null,
      'Job Title': job_title,
      'Channel ID':
        Array.isArray(channels) && channels.length ? channels[0].id : null,
      'Channel IDs':
        Array.isArray(channels) && channels.length
          ? channels.map((p) => p.id).toString()
          : null,
      'Channel Name':
        Array.isArray(channels) && channels.length ? channels[0].name : null,
      'Channel Names':
        Array.isArray(channels) && channels.length
          ? channels.map((p) => p.name).toString()
          : null,
      Analyst: !!analyst,
      'Analyst Job Title': analyst ? analyst.job_title : null,
      'Created At': created_at,
      'Is Mifid': is_mifid,
      'Is GDPR Compliant': is_gdpr_compliant,
      'Country Id': country_id,
      ...storeAttributes
    }

    window.heap.identify(`${id}`)
    window.heap.addUserProperties(_omitBy(userProps, _isNil))
    window.heap.addEventProperties({
      'Logged In': true,
      ...storeAttributes
    })
  }

  return true
}

export const addPrefixToObjectKeys = (obj: StringObject, prefix: String) =>
    Object.keys(obj).reduce(
      (acc, key) => ({
        ...acc,
        ...{[prefix +  key]: obj[key]},
      }),
      {},
    )
